export const entriesApprovalsRoute = '/entries-approvals';

export const getTimeApprovalIdEntryModalRoute = (tab: string, timesheetId: string, entry: string) => {
  return `${entriesApprovalsRoute}/${tab}/${timesheetId}/entry/${entry}` as const;
};
